import { NgModule } from "@angular/core";
import { SharedModule as AppSharedModule } from "../../shared/shared.module";
import { CommonExclusionDatesComponent } from "./common-exclusion-dates/common-exclusion-dates.component";
import { CaptionsComponent } from "./captions/captions.component";
import { AudioComponent } from "./audio/audio.component";
import { NumberDatePipe } from "./number-date.pipe";
import { WeekdayComponent } from "./weekday/weekday.component";
import { NumberInputComponent } from "./number-input/number-input.component";
import { NumberPeriodPipe } from "./number-period.pipe";
import { AttendeeListComponent } from "./attendee-list/attendee-list.component";
import { TimeComponent } from "./time/time.component";
import { DateComponent } from "./date/date.component";
import { DaysListComponent } from "./days-list/days-list.component";
import { SelectableTableComponent } from "./selectable-table/selectable-table.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { CollapsibleComponent } from "./collapsible/collapsible.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbDropdownModule, NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { TextMaskModule } from "./textmast.module";
import { MonthlyComponent } from "./monthly/monthly.component";
import { BookingTypePipe } from "./booking-type.pipe";
import { ConsumersComponent } from "./consumers/consumers.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { IconButtonComponent } from "./icon-button/icon-button.component";
import { CustomDatePipe } from "./custom-date.pipe";
import { DevLoginComponent } from "./dev-login/dev-login.component";
import { LoginComponent } from "./login/login.component";
import { RouterModule } from "@angular/router";
import { FocusableContainerComponent } from "./focusable-container/focusable-container.component";
import { FocusableDirective } from "./focusable.directive";
import { TimeZonesComponent } from "./time-zones/time-zones.component";
import { CheckboxListComponent } from "./checkbox-list/checkbox-list.component";
import { OptGroupDirective } from "./opt-group.directive";
import { CaptionRowComponent } from "./captions/caption-row/caption-row.component";
import { AddCaptionRowButtonComponent } from "./captions/add-caption-row-button/add-caption-row-button.component";
import { DeleteCaptionRowComponent } from "./captions/caption-row/delete-caption-row/delete-caption-row.component";
import { CaptionParamComponent } from "./captions/caption-row/caption-param/caption-param.component";
import { ForgotPasswordLinkComponent } from "./login/forgot-password-link/forgot-password-link.component";
import { TextareaLimitComponent } from "./textarea-limit/textarea-limit.component";
import { CloseButtonComponent } from "./close-button/close-button.component";
import { GoogleAuthButtonComponent } from "./google-auth-button/google-auth-button.component";
import { IconComponent } from "./icon/icon.component";
import { IconLinkComponent } from "./icon-link/icon-link.component";
import { StringListComponent } from "./string-list/string-list.component";
import { RadioListComponent } from "./radio-list/radio-list.component";
import { PrivateusersComponent } from "./privateusers/privateusers.component";
import { PrivateUserListComponent } from "./private-user-list/private-user-list.component";
import { CommonModule } from "@angular/common";
import { SortOrderPipe } from './sort-order.pipe';
import { NgMaterialModule } from 'src/app/core/ng-material/ng-material.module';
import { TzLabelPipe } from './tz-label.pipe';
import { MultipleWindowDialogComponent } from './multiple-window-dialog/multiple-window-dialog.component';
import { RatingDialogComponent } from './rating-dialog/rating-dialog.component';
import { BetaFeatureDialogComponent } from './beta-feature-dialog/beta-feature-dialog.component';
import { TermsAndConditionDialogComponent } from './terms-and-condition-dialog/terms-and-condition-dialog.component';
import { BetaFeatureTutorialDialogComponent } from './beta-feature-tutorial-dialog/beta-feature-tutorial-dialog.component';
import { DownloadTranscriptDialogComponent } from './download-transcript-dialog/download-transcript-dialog.component';
import { ErrorLabelComponent } from "./error-label/error-label.component";
import { QrCodeComponent } from "./qr-code/qr-code.component";
import { ServiceTypeLabelPipe } from './service-type-label.pipe';
import { RecurrenceSummaryPipe } from './recurrence-summary.pipe';
@NgModule({
    declarations: [
        CommonExclusionDatesComponent,
        CaptionsComponent,
        AudioComponent,
        NumberDatePipe,
        WeekdayComponent,
        NumberInputComponent,
        NumberPeriodPipe,
        AttendeeListComponent,
        DevLoginComponent,
        LoginComponent,
        TimeComponent,
        DateComponent,
        DaysListComponent,
        SelectableTableComponent,
        ConfirmationDialogComponent,
        CollapsibleComponent,
        MonthlyComponent,
        BookingTypePipe,
        ConsumersComponent,
        IconButtonComponent,
        CustomDatePipe,
        FocusableContainerComponent,
        FocusableDirective,
        TimeZonesComponent,
        CheckboxListComponent,
        OptGroupDirective,
        CaptionRowComponent,
        AddCaptionRowButtonComponent,
        DeleteCaptionRowComponent,
        CaptionParamComponent,
        ForgotPasswordLinkComponent,
        TextareaLimitComponent,
        IconComponent,
        IconLinkComponent,
        CloseButtonComponent,
        GoogleAuthButtonComponent,
        StringListComponent,
        RadioListComponent,
        PrivateusersComponent,
        PrivateUserListComponent,
        SortOrderPipe,
        TzLabelPipe,
        MultipleWindowDialogComponent,
        RatingDialogComponent,
        BetaFeatureDialogComponent,
        TermsAndConditionDialogComponent,
        BetaFeatureTutorialDialogComponent,
        DownloadTranscriptDialogComponent,
        ErrorLabelComponent,
        ServiceTypeLabelPipe,
        RecurrenceSummaryPipe,
    ],
    imports: [
        NgMaterialModule,
        AppSharedModule,
        RouterModule,
        NgSelectModule,
        NgbModalModule,
        NgbDropdownModule,
        TextMaskModule,
        AngularSvgIconModule,
        QrCodeComponent,
    ],
    exports: [
        NgMaterialModule,
        AppSharedModule,
        NgSelectModule,
        NgbModalModule,
        NgbDropdownModule,
        TextMaskModule,
        CommonModule,
        CommonExclusionDatesComponent,
        CaptionsComponent,
        AudioComponent,
        SelectableTableComponent,
        TimeComponent,
        DateComponent,
        WeekdayComponent,
        AttendeeListComponent,
        CollapsibleComponent,
        NumberDatePipe,
        NumberInputComponent,
        DevLoginComponent,
        LoginComponent,
        DaysListComponent,
        MonthlyComponent,
        BookingTypePipe,
        ConsumersComponent,
        AngularSvgIconModule,
        IconButtonComponent,
        IconLinkComponent,
        CustomDatePipe,
        FocusableContainerComponent,
        FocusableDirective,
        TimeZonesComponent,
        CheckboxListComponent,
        RadioListComponent,
        TextareaLimitComponent,
        CloseButtonComponent,
        StringListComponent,
        GoogleAuthButtonComponent,
        PrivateUserListComponent,
        SortOrderPipe,
        TzLabelPipe,
        ErrorLabelComponent,
        ServiceTypeLabelPipe,
        RecurrenceSummaryPipe,
        QrCodeComponent,
    ],
})
export class SharedModule {}
